// Package Module Constants
export const PACKAGE_STEPS = {
  STEP_1: {
    id: 1,
    label: "packages.fields.selectARoom"
  },
  STEP_2: {
    id: 2,
    label: "packages.fields.addMoreRooms"
  },
  STEP_3: {
    id: 3,
    label: "booking.roomDetails"
  },
  STEP_4: {
    id: 4,
    label: "transfers.fields.transferDetails"
  },
  STEP_5: {
    id: 5,
    label: "packages.fields.addAnotherTransfer"
  },
  STEP_6: {
    id: 6,
    label: "packages.fields.completePersonalDetails"
  }
} as const;

export const TOTAL_STEPS = 6;
